import React, { useState } from 'react'
import { useSearchParams } from 'react-router-dom';
import PreviewCard from '../../../components/PreviewCard/PreviewCard'
import { useGetUserWithCodeQuery } from '../../../utils/api/user/userApi';

const Profile = () => {
  let [searchParams] = useSearchParams(); 
   

  return (
    <section className="relative max-w-7xl mx-auto   py-8 px-6 sm:px-8 xl:px-0 ">
      <div className="flex justify-center  ">
        <div className=" ">
        <PreviewCard uid={searchParams.get("code")} fromLink={true}/>
        </div>
      </div>
   
      </section>
  )
}

export default Profile